import { apiPost } from './api';
import type { AIGeneratedContent } from '@data/publicPlans';

type LanguageCode = 'en' | 'de' | 'hr';

const translationCache = new Map<string, Promise<AIGeneratedContent>>();

function buildCacheKey(content: AIGeneratedContent, language: LanguageCode): string {
	return `${language}::${JSON.stringify(content)}`;
}

export async function translateAIContent(
	content: AIGeneratedContent,
	targetLanguage: LanguageCode
): Promise<AIGeneratedContent> {
	if (content.contentLanguage === targetLanguage) {
		return content;
	}

	const key = buildCacheKey(content, targetLanguage);
	const cached = translationCache.get(key);
	if (cached) return cached;

	const request = apiPost<AIGeneratedContent>('/translate-ai-content', {
		content,
		target_language: targetLanguage
	})
		.then((res) => ({ ...(res ?? content), contentLanguage: targetLanguage }))
		.catch(() => content);

	translationCache.set(key, request);
	return request;
}

